import { render, staticRenderFns } from "./u-icon.vue?vue&type=template&id=0fb6b370&"
import script from "./u-icon.vue?vue&type=script&lang=js&"
export * from "./u-icon.vue?vue&type=script&lang=js&"
import style0 from "./u-icon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports